// YouTube helpers shared by the timeline, box insertion, and the search panels.
// A YouTube box stores an embed URL — its duration cannot be probed with a
// <video> element, so it is fetched from the Data API instead.

export const YOUTUBE_API_KEY = "AIzaSyCnCtUmlZ432Ak88LohJoSAZygWw-JN4rc";

const YT_URL_RE =
  /(?:youtu\.be\/|youtube(?:-nocookie)?\.com\/(?:embed\/|v\/|shorts\/|live\/|watch\?v=|watch\?.+&v=))([\w-]{11})/;

export function getYoutubeVideoId(url) {
  if (typeof url !== "string") return null;
  const m = url.match(YT_URL_RE);
  return m ? m[1] : null;
}

export function isYoutubeUrl(url) {
  return getYoutubeVideoId(url) !== null;
}

// Cover image for a YouTube video — the embed URL itself renders nothing
// inside <img>/<video> elements. quality: mqdefault (320×180) for small
// thumbs, hqdefault (480×360) for larger previews.
export function getYoutubeThumbnailUrl(url, quality = "mqdefault") {
  const id = getYoutubeVideoId(url);
  return id ? `https://i.ytimg.com/vi/${id}/${quality}.jpg` : null;
}

// "PT1H2M10S" → seconds
function parseIsoDuration(iso) {
  const m = /^P(?:(\d+)D)?T?(?:(\d+)H)?(?:(\d+)M)?(?:(\d+(?:\.\d+)?)S)?$/.exec(iso || "");
  if (!m) return null;
  const [, d, h, min, s] = m;
  const total =
    (parseInt(d || 0, 10) * 24 + parseInt(h || 0, 10)) * 3600 +
    parseInt(min || 0, 10) * 60 +
    parseFloat(s || 0);
  return Number.isFinite(total) && total > 0 ? total : null;
}

const _durationPromises = new Map();

// Duration in seconds, or null when unavailable (bad id, quota, network).
// Memoized per video id — a failed lookup is not retried within the session.
export function fetchYoutubeDuration(url) {
  const id = getYoutubeVideoId(url);
  if (!id) return Promise.resolve(null);
  if (_durationPromises.has(id)) return _durationPromises.get(id);
  const p = fetch(
    "https://www.googleapis.com/youtube/v3/videos?part=contentDetails&id=" +
      id +
      "&key=" +
      YOUTUBE_API_KEY
  )
    .then((res) => (res.ok ? res.json() : null))
    .then((data) => {
      const iso =
        data && data.items && data.items[0] && data.items[0].contentDetails
          ? data.items[0].contentDetails.duration
          : null;
      return parseIsoDuration(iso);
    })
    .catch(() => null);
  _durationPromises.set(id, p);
  return p;
}
